export default __webpack_public_path__ + "static/media/note.1c4b984d.svg";